import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { FiltersContext } from "../../context/filtersContext";
import { LangContext } from "../../context/langContext";
import { FilterCardContainer } from "./FilterCardStyled";


export default function FilterCard({ filter, type }) {

    const navigate = useNavigate();

    const { locale } = useContext(LangContext);
    const { categoryFilter, networkFilter, setNetworkFilter, setCategoryFilter } = useContext(FiltersContext);

    const handlerCategoryFilter = (categoryId) => {
        const auxCategoryFilter = [...categoryFilter];
        if (auxCategoryFilter.includes(categoryId)) {
            const newCategory = auxCategoryFilter.filter(cat => cat !== categoryId);
            setCategoryFilter(newCategory)
            navigate('/influencers')
        } else {
            auxCategoryFilter.push(categoryId);
            setCategoryFilter(auxCategoryFilter);
            navigate('/influencers')
        }
    }

    const handlerNetworkFilter = (network) => {

        const auxNetworkFilter = [...networkFilter];

        if (auxNetworkFilter.includes(network)) {
            const newNetwork = auxNetworkFilter.filter(net => net !== network);
            setNetworkFilter(newNetwork);
            navigate('/influencers');

        } else {
            auxNetworkFilter.push(network);
            setNetworkFilter(auxNetworkFilter);
            navigate('/influencers');
        }
    }

    return (
        <FilterCardContainer image={filter.image} onClick={() => {
            if (type === 'category') {
                handlerCategoryFilter(filter.id)
            } else {
                handlerNetworkFilter(filter.name)
            }

        }}>
            <div className="degrade">
                <p className="text">{(locale === 'es-CO') ? filter.nombre : filter.name}</p>
            </div>
        </FilterCardContainer>
    )
}